module.exports = __webpack_public_path__ + "fonts/tt_sushkof_medium.eb86065.woff2";